// extracted by mini-css-extract-plugin
module.exports = {"default_details_container":"_2laeRuo"};